module.exports = __webpack_public_path__ + "img/microflavours.489cfce7.jpeg";